import { Image } from 'expo-image'
import { LinearGradient } from 'expo-linear-gradient'
import { useState } from 'react'
import { View } from 'react-native'
import Animated, { ReduceMotion, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated'

import { ProgressBar } from '@/src/elements/progress-bar/ProgressBar'
import { Typography } from '@/src/elements/text/Typography'
import { useTimeout } from '@/src/general/hooks/useTimeout'
import { useTranslate } from '@/src/lang/useTranslate'
import { colors } from '@/src/styles/colors'

const cards = [
  {
    progress: 0,
    title: 'Neuvaine à Saint-Michel',
    image: require('@/img/onboarding/journey-thumbnail-1.webp'),
    key: 1,
  },
  {
    progress: 30,
    title: "Parcours d'été : \"L'art d'aimer Jésus\" ...",
    image: require('@/img/onboarding/journey-thumbnail-2.webp'),
    key: 2,
  },
  {
    progress: 70,
    title: '100 jours pour lire Magnifica Humanitas',
    image: require('@/img/onboarding/journey-thumbnail-3.webp'),
    key: 3,
  },
] as const

export const StepTwo = () => {
  const [progress, setProgress] = useState(10)
  const sharedBlurRadius = useSharedValue(0)
  const sharedSpreadDistance = useSharedValue(0)
  const cardsTranslateX = useSharedValue(0)

  const { t } = useTranslate()

  useTimeout(() => {
    setProgress(100)
  }, 100)

  useTimeout(() => {
    sharedSpreadDistance.value = withTiming(3, { duration: 100 })
    sharedBlurRadius.value = withTiming(8, { duration: 100 })
  }, 1000)

  useTimeout(() => {
    cardsTranslateX.value = withTiming(-324, { duration: 1000, reduceMotion: ReduceMotion.System })
  }, 1500)

  const cardsAnimatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: cardsTranslateX.value }],
  }))

  const animatedShadow = useAnimatedStyle(() => ({
    borderRadius: 12,
    boxShadow: [
      {
        offsetX: 0,
        offsetY: 0,
        blurRadius: sharedBlurRadius.value,
        spreadDistance: sharedSpreadDistance.value,
        color: '#FFFFFF',
        inset: false,
      },
    ],
  }))

  return (
    <View className="overflow-hidden">
      <Typography size="lg" black colors="primary" contrast="default" className="mt-2 mx-6">
        {t('prayer-space.onboarding.step-2.title')}
      </Typography>
      <Animated.View
        style={[
          {
            marginTop: 24,
            marginBottom: 24,
            flexDirection: 'row',
            gap: 16,
          },
          cardsAnimatedStyle,
        ]}
      >
        <View className="w-2" />
        {cards.map(({ progress: staticProgress, title, image, key }, index) => (
          <View key={key} className="h-44 w-52 rounded-xl overflow-hidden justify-end p-4">
            <Image source={image} contentFit="cover" className="absolute inset-0 h-full w-full" />
            <LinearGradient
              locations={[0.2, 0.9]}
              className="absolute inset-0 h-full w-full"
              colors={['transparent', 'rgba(0,0,0,0.8)']}
            />
            <Typography className="mb-4" bold colors="white">
              {title}
            </Typography>
            <Animated.View style={[index === 0 ? animatedShadow : {}]}>
              <ProgressBar
                className={'max-h-2 bg-gray-800/[0.6]'}
                progress={index === 0 ? progress : staticProgress}
                fill={progress !== 100 || index > 0 ? '#FFFFFF' : colors['accents']['green']['strong']}
              />
            </Animated.View>
          </View>
        ))}
      </Animated.View>
      <Typography colors="primary" contrast="high" className="mx-6" size="sm">
        {t('prayer-space.onboarding.step-2.description')}
      </Typography>
    </View>
  )
}
